<template>
    <div v-if="webInfo">
        <div v-for="(item, index) in webInfo.WidgetVibes.vibesInfo" :key="index">
            <div class="elementTitle">{{item.elementTitle}}</div>
            <div class="elementLabel">{{item.elementLabel}}</div>
            <div class="vibesListDiv">
                <el-row :gutter="10">
                    <el-col :span="6" v-for="(itemA, indexA) in item.vibesList" :key="indexA">
                        <div class="detailsCard">
                            <el-image lazy style="height: 100%;width: 100%;display: block;" :src="globalConfig.filePath + itemA.src" fit="cover"></el-image>
                            <p class="imgLabel">{{itemA.text}}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                webInfo: null,
            };
        },
        updated() {},
        mounted() {
            var that = this;
            that.webInfo = that.$parent.webInfo;
        },
        methods: {},
    };
</script>

<style scoped>
    .elementTitle {
        font-size: 32px;
        font-weight: bold;
        line-height: 60px;
        width: 100%;
        text-align: center;
    }

    .elementLabel {
        font-size: 16px;
        line-height: 30px;
        width: 100%;
        text-align: center;
    }

    .vibesListDiv {
        width: 65%;
        margin: 20px auto;
    }

    .vibesListDiv .el-col {
        margin: 5px auto;
    }

    .detailsCard {
        width: 100%;
    }

    .detailsCard >>> img {
        transition: 0.3s;
    }

    .detailsCard >>> img:hover {
        transform: scale(1.1);
    }

    .imgLabel {
        background: #236de9;
        color: #fff;
        line-height: 40px;
        height: 40px;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 10px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/components/Widget/WidgetVibes.vue